export const Urls = {
    WesternBidUserAgreementFile:"https://westernbid.link/western-bid-in-english/wbuseragreement.pdf",
    WesternBidPrivacyPolicyFile: "https://westernbid.link/western-bid-in-english/pp.pdf",
    WesternBidShippingAndHandlingPolicyFile: "https://westernbid.link/western-bid-in-english/sh.pdf",
    WesternBid: "https://westernbid.com",
    GetHelp: "https://westernbid.com/en/articles/help"
};